<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Manage Expenses{{ (month ? ' for ' + monthName(month) : '') + ' ' + (year ? ' ' + year : '') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-container fluid grid-list-xs class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-container fluid grid-list-lg>
                    <v-form ref="frmLoadExpenses" v-model="frmLoadExpensesValid" v-on:submit.prevent>
                      <v-layout row wrap>
                        <v-flex xs4 sm3 offset-sm2>
                          <v-select
                            v-model="cboMonth"
                            :items="months"
                            item-text="name"
                            item-value="value"
                            label="Month"
                            :rules="[v => !!v || 'Month is required']"
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs4 sm3>
                          <v-select
                            v-model="cboYear"
                            :items="years"
                            label="Year"
                            :rules="[v => !!v || 'Year is required']"
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs4 sm1>
                          <v-btn
                            outline
                            small
                            :disabled="!frmLoadExpensesValid"
                            @click="$router.push('/expenses/' + cboYear + '/' + cboMonth)"
                          >
                            Load
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="(year >= 2000 && year <= 3000) && (month >= 1 && month <= 12)">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="(year >= 2000 && year <= 3000) && (month >= 1 && month <= 12)" class="pt-5">
                  <v-card flat class="pt-0" v-if="expenses.length > 0">
                    <v-container fluid grid-list-xs class="pt-0">
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          text-xs-center
                          layout
                          align-center
                          justify-center
                          class="mt-0"
                        >
                          <table
                            class="pt-0 mt-0"
                            style="width: 100%;"
                          >
                            <tr v-for="(branch, branchIndex) in expenses" :key="branchIndex">
                              <td class="text-xs-left title font-weight-regular">
                                <strong>{{ branch.branchName }}</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr v-for="(expense, expenseIndex) in branch.expenses" :key="expense.expenseId">
                                    <td width="60%" class="body-2 font-weight-regular">
                                      <div>
                                        {{ expense.name }}
                                        <v-btn
                                          small
                                          outline
                                          class="ml-2"
                                          v-if="expense.remarks.length > 0"
                                          @click="showRemarks(expense)"
                                        >
                                          Remarks
                                        </v-btn>
                                        <v-btn
                                          small
                                          icon
                                          class="mr-0 grey--text text--darken-1"
                                          v-if="accessDeleteExpense"
                                          @click="showDeleteExpenseDialog(expense)"
                                        >
                                          <v-icon small>delete</v-icon>
                                        </v-btn>
                                        <v-btn
                                          small
                                          icon
                                          class="ml-0 grey--text text--darken-1"
                                          v-if="accessUpdateExpense"
                                          @click="showEditExpenseDialog(expense)"
                                        >
                                          <v-icon small>edit</v-icon>
                                        </v-btn>
                                      </div>
                                      <div class="caption grey--text text--darken-1">
                                        <span v-if="expense.updatedByAdminName.length > 0">Updated by {{ expense.updatedByAdminName }} on {{ expense.updatedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                                        <span v-else-if="expense.createdByAdminName.length > 0">Added by {{ expense.createdByAdminName }} on {{ expense.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                                      </div>
                                    </td>
                                    <td width="30%" class="body-2 font-weight-regular" :style="(expenseIndex >= (branch.expenses.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                      {{ def.currency.sign + formatPrice(expense.amountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                      <span v-if="expense.currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text ml-3">({{ expense.currencySign }}{{ formatPrice(expense.amount, expense.currencyDecimals, expense.currencyDecimalSign) }})</span>
                                    </td>
                                    <td width="10%" class="title font-weight-regular">
                                      <span v-if="expenseIndex >= (branch.expenses.length - 1)">+</span>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                {{ def.currency.sign + formatPrice(branch.totalAmountInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left title font-weight-regular">
                                <strong>Total</strong>
                              </td>
                              <td class="text-xs-right title font-weight-bold" valign="bottom">
                                {{ def.currency.sign + formatPrice(totalExpensesInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                          </table>
                        </v-flex>
                        <v-flex
                          xs12
                          layout
                          text-xs-left
                          class="mt-5"
                          v-if="accessCreateExpense"
                        >
                          <v-btn
                            small
                            outline
                            @click="showAddExpenseDialog"
                          >
                            Add Expenses
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>

          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="addExpenseDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Add Expenses</h3>
          <v-form ref="frmAddExpense" v-model="frmAddExpenseValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Name"
                    v-model="txtExpenseName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="cboExpenseBranchId"
                    v-bind:items="branches"
                    label="Branch"
                    item-text="name"
                    item-value="branchId"
                  ></v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select
                    v-model="cboExpenseCurrencyCode"
                    v-bind:items="currencies"
                    label="Currency"
                    item-text="sign"
                    item-value="currencyCode"
                    :rules="[v => !!v || 'Currency is required']"
                    required
                    @change="txtExpenseExchangeRateToBase = getRateToBase(cboExpenseCurrencyCode)"
                  ></v-select>
                </v-flex>
                <v-flex xs9>
                  <v-text-field
                    label="Amount"
                    v-model="txtExpenseAmount"
                    :rules="[v => !!v || 'Amount is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="cboExpenseCurrencyCode.length > 0 && cboExpenseCurrencyCode !== def.currency.currencyCode">
                  <v-text-field
                    label="Rate to USD"
                    v-model="txtExpenseExchangeRateToBase"
                    :rules="[v => !!v || 'Rate to USD is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <trumbowyg id="trumbowyg" v-model="txtExpenseRemarks" :config="trumbowygConfig"></trumbowyg>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmAddExpenseValid"
                    @click="addExpense"
                  >
                    Add
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="editExpenseDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Edit Expenses</h3>
          <v-form ref="frmEditExpense" v-model="frmEditExpenseValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Name"
                    v-model="txtExpenseName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="cboExpenseBranchId"
                    v-bind:items="branches"
                    label="Branch"
                    item-text="name"
                    item-value="branchId"
                  ></v-select>
                </v-flex>
                <v-flex xs5>
                  <v-select
                    v-model="cboExpenseCurrencyCode"
                    v-bind:items="currencies"
                    label="Currency"
                    item-text="sign"
                    item-value="currencyCode"
                    :rules="[v => !!v || 'Currency is required']"
                    required
                    @change="txtExpenseExchangeRateToBase = getRateToBase(cboExpenseCurrencyCode)"
                  ></v-select>
                </v-flex>
                <v-flex xs7>
                  <v-text-field
                    label="Amount"
                    v-model="txtExpenseAmount"
                    :rules="[v => !!v || 'Amount is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="cboExpenseCurrencyCode.length > 0 && cboExpenseCurrencyCode !== def.currency.currencyCode">
                  <v-text-field
                    label="Rate to USD"
                    v-model="txtExpenseExchangeRateToBase"
                    :rules="[v => !!v || 'Rate to USD is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <trumbowyg id="trumbowyg" v-model="txtExpenseRemarks" :config="trumbowygConfig"></trumbowyg>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmEditExpenseValid"
                    @click="editExpense(selectedExpense.expenseId)"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deleteExpenseDialog"
        max-width="300"
      >
        <v-card>
          <v-card-title class="subheading font-weight-bold">Are you sure to remove this expenses?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat="flat"
              @click="deleteExpenseDialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteExpense(selectedExpense.expenseId)"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="viewRemarksDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">{{ expenseToView.name }}</h3>
          <div class="mt-3" v-html="expenseToView.remarks"></div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>

  </div>
</template>

<style scoped>

form >>> div.trumbowyg-box.trumbowyg-editor-visible.trumbowyg-en.trumbowyg {
  z-index: 1;
}

td, th {
  padding: 15px 15px;
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css'
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

let $ = window.$

export default {
  props: [
    'year',
    'month'
  ],
  components: {
    SideDrawer,
    Trumbowyg,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['table'],
          ['removeformat'],
          ['upload'],
          ['fullscreen']
        ],
        plugins: {
          upload: {
            serverPath: process.env.VUE_APP_API_ROOT + '/v1/costing/expense/wysiwyg/image',
            fileFieldName: 'image',
            headers: {
              'Authorization': axios.defaults.headers.common['Authorization'],
              'X-API-KEY': axios.defaults.headers.common['X-API-KEY']
            },
            urlPropertyName: 'url'
          },
          resizimg: {
            minSize: 64
          }
        }
      },
      accessCreateExpense: false,
      accessReadExpense: false,
      accessUpdateExpense: false,
      accessDeleteExpense: false,
      cboYear: '',
      cboMonth: '',
      years: [],
      branches: [],
      currencies: [],
      currencyCode: this.$store.getters.getDef.currency.currencyCode,
      currencySign: this.$store.getters.getDef.currency.sign,
      currencyDecimals: this.$store.getters.getDef.currency.decimals,
      currencyDecimalSign: this.$store.getters.getDef.currency.decimalSign,
      exchangeRateToBase: this.$store.getters.getDef.currency.exchangeRateToBase,
      frmLoadExpensesValid: false,
      addExpenseDialog: false,
      frmAddExpenseValid: false,
      txtExpenseName: '',
      cboExpenseBranchId: '',
      cboExpenseCurrencyCode: '',
      txtExpenseExchangeRateToBase: 1,
      txtExpenseAmount: '',
      txtExpenseRemarks: '',
      selectedExpense: {},
      editExpenseDialog: false,
      frmEditExpenseValid: false,
      deleteExpenseDialog: false,
      viewRemarksDialog: false,
      expenseToView: '',
      expenses: [],
      totalExpensesInBase: 0
    }
  },
  computed: {
  },
  mounted () {
    this.openDrawerForDesktop()
    this.years = this.generateYearsToCurrentYear(2020)
    this.getCurrencies()
    this.getBranches()
    if (typeof this.year !== 'undefined' && this.year > 0) {
      if (typeof this.month !== 'undefined' && this.month > 0) {
        this.getExpenses(this.year, this.month)
      }
    }

    // determine expense access
    for (let i = 0; i < this.profile.permissions.length; i++) {
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isCreate === '1') {
        this.accessCreateExpense = true
      }
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isRead === '1') {
        this.accessReadExpense = true
      }
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isUpdate === '1') {
        this.accessUpdateExpense = true
      }
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isDelete === '1') {
        this.accessDeleteExpense = true
      }
    }

    var _this = this
    $('#trumbowyg')
      .trumbowyg() // Build Trumbowyg on the #editor element
      .on('tbwopenfullscreen', function () { _this.drawer = false; _this.isTrumbowygFullscreen = true })
      .on('tbwclosefullscreen', function () { _this.isTrumbowygFullscreen = false; _this.drawer = true })
  },

  methods: {
    showRemarks: function (expense) {
      this.expenseToView = expense
      this.viewRemarksDialog = true
    },
    showAddExpenseDialog: function () {
      this.txtExpenseName = ''
      this.cboExpenseBranchId = ''
      this.cboExpenseCurrencyCode = ''
      this.txtExpenseExchangeRateToBase = 1
      this.txtExpenseAmount = ''
      this.txtExpenseRemarks = ''
      this.addExpenseDialog = true
    },
    showDeleteExpenseDialog: function (expense) {
      this.selectedExpense = expense
      this.deleteExpenseDialog = true
    },
    showEditExpenseDialog: function (expense) {
      this.selectedExpense = expense
      this.cboExpenseBranchId = expense.branchId
      this.txtExpenseName = expense.name
      this.cboExpenseCurrencyCode = expense.currencyCode
      this.txtExpenseExchangeRateToBase = expense.exchangeRateToBase
      this.txtExpenseAmount = expense.amount
      this.txtExpenseRemarks = expense.remarks
      this.editExpenseDialog = true
    },
    addExpense () {
      var _this = this
      if (_this.$refs.frmAddExpense.validate()) {
        _this.loading = true
        var data = {
          year: _this.year,
          month: _this.month,
          name: _this.txtExpenseName,
          branchId: _this.cboExpenseBranchId,
          currencyCode: _this.cboExpenseCurrencyCode,
          exchangeRateToBase: _this.txtExpenseExchangeRateToBase,
          amount: _this.txtExpenseAmount,
          remarks: _this.txtExpenseRemarks
        }

        axios.post(process.env.VUE_APP_API_ROOT + '/v1/costing/expense', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getExpenses(_this.year, _this.month)
              _this.addExpenseDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    editExpense (expenseId) {
      var _this = this
      if (_this.$refs.frmEditExpense.validate()) {
        _this.loading = true
        var data = {
          name: _this.txtExpenseName,
          branchId: _this.cboExpenseBranchId,
          currencyCode: _this.cboExpenseCurrencyCode,
          exchangeRateToBase: _this.txtExpenseExchangeRateToBase,
          amount: _this.txtExpenseAmount,
          remarks: _this.txtExpenseRemarks
        }

        axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/expense/' + expenseId, data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getExpenses(_this.year, _this.month)
              _this.editExpenseDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    deleteExpense (expenseId) {
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/costing/expense/' + expenseId)
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getExpenses(_this.year, _this.month)
            _this.deleteExpenseDialog = false
          } else {
            window.alert('unable to remove expenses: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              _this.$store.dispatch('AUTH_LOGOUT')
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getBranches: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/branches')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            let temp = [
              {
                branchId: '',
                name: ''
              }
            ]
            _this.branches = temp.concat(resp.data.data)
          } else {
            console.log('unable to load branches: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === _this.currencyCode) {
                resp.data.data[i].exchangeRateToBase = _this.exchangeRateToBase
              }
            }
            _this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getRateToBase: function (currencyCode) {
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          return this.currencies[i].exchangeRateToBase
        }
      }
      return 0
    },
    getExpenses: function (year, month) {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/costing/expenses/' + year + '/' + month)
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.expenses = resp.data.data
            _this.cboYear = parseInt(year)
            _this.cboMonth = parseInt(month)
            let totalExpenses = 0
            for (let i in resp.data.data) {
              totalExpenses += resp.data.data[i].totalAmountInBase
            }
            _this.totalExpensesInBase = totalExpenses
          } else {
            window.alert('Invalid year / month')
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
          _this.loading = false
        })
    }
  }
}
</script>
